// import igbc from '../images/IGBC.png'
// import iitk_logo from "../images/iitk_logo.png"
// import nselogo from '../images/NSE-logo.png'
import "../../stylesheets2025/Author.css";
import SupportersLogo from '../../components2026/SupportersLogo'
// import goi from "../images/Government_of_India_logo.png"
// import moefcc from "../images/moefcc-logo.jpg"
// import gom from "../images/Seal_of_Maharashtra.svg.webp"

const Supporters = () => {
  return (
    <>
      <div className="life-sponsors flex flex-col justify-center items-center pt-4">
        <div className="org">
          <p><h1 className='text-center dgreen'>SANKET</h1></p>
        </div>
        <style>{`
  @keyframes orgFadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .org-logo-item {
    opacity: 0;
    animation: orgFadeUp 0.55s ease forwards;
    display: flex;
    align-items: center;
  }
  .org-logo-img {
    height: 130px;
    max-width: 160px;
    object-fit: contain;
    transition: transform 0.3s ease, filter 0.3s ease;
  }
  .org-logo-img:hover {
    transform: scale(1.1);
    filter: drop-shadow(0 4px 14px rgba(0,120,70,0.3));
  }
`}</style>

        <span className="text-center text-lg font-bold my-2">Organized by</span>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: '2.5rem', margin: '1rem 0 1.5rem' }}>
          {[
            ...SupportersLogo.Organiser,
            ...[...SupportersLogo.Associate].sort((a, b) => {
              const order = ['KSOS', 'IITB', 'IGBC', 'National Warangal'];
              const getIdx = (item) => {
                const found = order.findIndex(o => item.title.toLowerCase().includes(o.toLowerCase()));
                return found === -1 ? 99 : found;
              };
              return getIdx(a) - getIdx(b);
            }),
          ].map((item, idx) => {
            const sizeMap = {
              'GEV': { height: '110px', maxWidth: '160px' },
              'KSOS': { height: '70px', maxWidth: '300px' },
              'IITB': { height: '110px', maxWidth: '160px' },
              'IGBC': { height: '130px', maxWidth: '160px' },
              'National Warangal': { height: '110px', maxWidth: '160px' },
            };
            const imgStyle = sizeMap[item.title] || { height: '110px', maxWidth: '160px' };

            return (
              <div key={item.title} className="org-logo-item" style={{ animationDelay: `${idx * 0.13}s` }}>
                <a href={item.webpage} target="_blank" rel="noopener noreferrer">
                  <img
                    className="org-logo-img"
                    src={item.img}
                    alt={item.title}
                    style={{ ...imgStyle, objectFit: 'contain' }}
                  />
                </a>
              </div>
            );
          })}
        </div>
        {/* <span className='text-center text-lg font-bold my-2'>Organized by </span>

        <div className="supporters-logos">

          {SupportersLogo.Organiser.map((item) => (
            <div className={item.title}>
              <a href={item.webpage} target="_blank"><img src={item.img} alt={item.title} /></a>
            </div>
          ))}

        </div> */}


        {/* <span className='text-center text-lg font-bold my-2'>In association with </span>

        <div className="supporters-logos">
          {SupportersLogo.Associate.map((item) => (
            <div className={item.title + ' rounded '}>
              <a href={item.webpage} target="_blank"><img className="h-32" src={item.img} alt={item.title} /></a>
            </div>
          ))}
        </div> */}




        {/*   <span className='text-center text-lg font-bold my-2'>Venue Partner </span>

        <div className="supporters-logos">
          {SupportersLogo.Venue.map((item) => (
            <div className={item.title}>
              <a href={item.webpage} target="_blank"><img className="h-28" src={item.img} alt={item.title} /></a>
            </div>
          ))}
        </div> */}

        {/* <span className='text-center text-lg font-bold my-2'>Supported By </span> */}

        {/* <div className="supporters-logos">
          <div className="goi w-full  lg:w-auto">
            <div className="goi-sub flex ">
              <img className="h-16 lg:h-24" src={goi} alt="Govt.of India" />
              <img className="h-16 lg:h-24" src={moefcc} alt="MOEFCC" />
            </div>
            <h5 className='text-center text-sm lg:text-xl'>Ministry of Environment,<br/>
            Forest & Climate Change</h5>

          </div>

          <div className="gom">
          <div className="gom-sub flex items-center gap-2">
              <img className="h-16 lg:h-24" src={gom} alt="Govt.of Maharashtra" />
              <h5 className='font-bold text-center text-sm lg:text-xl'>Government of <br/>
              Maharashtra</h5>
            </div>
            <h5 className='text-center text-sm lg:text-xl '>Ministry of Urban Development | Forest<br/>
            Department | Department of Water Resources</h5>
          </div>
        </div>

        <div className="supporters-logos lg:w-4/5 s lg:flex align-center m-10 grid-cols-3 lg:grid-cols-5 ga-0">
          {SupportersLogo.Supporters_1.map((item) => {
            if (item.title === "IIT Bombay" || item.title === "IIT Indore" || item.title === "NIT Warangal") {
              return (<div className={item.title}>
                <a href={item.webpage} target="_blank"><img className="h-20 lg:h-24" src={item.img} alt={item.title} /></a>
                <h5 className='text-center text-xs lg:text-xl'>{item.title}</h5>
              </div>)
            } else {
              return (
                <div className={item.title}>
                  <a href={item.webpage} target="_blank"><img className="h-20 lg:h-24" src={item.img} alt={item.title} /></a>

                </div>
              )
            }
          }

          )}
          {SupportersLogo.Supporters_2.map((item) => (
            <div className={item.title}>
              <a href={item.webpage} target="_blank"><img src={item.img} alt={item.title} /></a>
            </div>
          ))}

        </div> */}
        {/* <div className="supporters-logos ga-0">
          {SupportersLogo.Supporters_2.map((item) => (
            <div className={item.title}>
              <a href={item.webpage} target="_blank"><img src={item.img} alt={item.title} /></a>
            </div>
          ))}
        </div> */}

        <div className="skills" id="skills">
          {/* {
            SponsorsImg.map((sponsor) => {
              return (
                <div className="card" key={sponsor.id}>
                  <img src={sponsor.image} alt="" />
                </div>
              )
            }
            )} */}


        </div>
      </div>

      <div className="cmt-acknowledgement mt-10 mb-8">
        <h3>CMT Acknowledgement</h3>
        <p>
          The Microsoft CMT service was used for managing the peer-reviewing process for this
          conference. This service was provided for free by Microsoft and they bore all expenses
          and services as well as for software development and support.
        </p>
      </div>

    </>
  )
}

export default Supporters;
